

    require('../coord/parallel/parallelCreator');
    require('./axis/parallelAxisAction');
    require('./axis/ParallelAxisView');




//////////////////
// WEBPACK FOOTER
// ./node_modules/echarts/lib/component/parallelAxis.js
// module id = 813
// module chunks = 0